import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-metafielddependenciesnew",
  templateUrl: "./metafielddependenciesnew.component.html",
  styleUrls: ["./metafielddependenciesnew.component.scss"],
})
export class MetafielddependenciesnewComponent implements OnInit {
  fieldList = [];
  mode: any;
  metaobjectId: any;
  metaobjectName: any;
  isLoading: boolean;
  fields: any;
  errorMessage: any;
  isError: boolean;
  selectedControllingField: any;
  selectedDependentField: any;
  guid: GUID;
  detailForm = this.fb.group({
    controllingfield: "",
    dependentfield: "",
    // object: "",
  });
  sourceOptions = [];

  targetOptions = [];
  metafieldDependencyId: string;
  fieldDependency: any;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode || "new"; // Default to 'new' if mode is not provided
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.metafieldDependencyId = this.route.snapshot.params.id;
    });
    this.guid = new GUID();

    // this.getMetaFieldsForSelection();

    console.log("mode", this.mode);
    console.log("metaobjectId", this.metaobjectId);
    console.log("metaobjectName", this.metaobjectName);

    // if (this.mode.toLocaleLowerCase().trim() == "edit") {
    //   this.getMetaFieldsForSelection().then((res) => {
    //     console.log("response11111", res);
    //     console.log("fields", this.fieldList);
    //     this.getFieldDependencyById();

    //     console.log(this.detailForm.controls["dependentfield"].value);
    //   });
    // }
    if (this.mode.toLowerCase().trim() === "edit") {
      this.getMetaFieldsForSelection().then(() => {
        this.getFieldDependencyById().then(() => {
          // Trigger change detection after data is set
          this.cdr.detectChanges();
        });
      });
    } else {
      this.getMetaFieldsForSelection();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  previousSources: string[] = [];

  // onSourceChange(value: string, index: number) {
  //   const isDuplicate = this.mappings.some(
  //     (m, i) => i !== index && m.source === value
  //   );

  //   if (isDuplicate) {
  //     // Revert the selection
  //     setTimeout(() => {
  //       this.mappings[index].source = this.previousSources[index] || "";
  //     });
  //     // Optional: show message
  //     // alert(`"${value}" is already selected in another row.`);
  //     this.showWarning(`"${value}" is already selected in another row.`);
  //   } else {
  //     this.previousSources[index] = value;
  //   }
  // }

  onSourceChange(value: string, index: number) {
    const isDuplicate = this.mappings.some(
      (m, i) => i !== index && m.source === value
    );

    if (isDuplicate) {
      setTimeout(() => {
        this.mappings[index].source = this.previousSources[index] || "";
      });
      this.showWarning(`"${value}" is already selected in another row.`);
    } else {
      this.mappings[index].source = value; // ✅ Explicitly update mapping
      this.previousSources[index] = value;
    }
  }

  controllingFieldChange(event: any) {
    console.log("field event", event);
    console.log("field event options", event.options);
    this.selectedControllingField = event.label;
    if (!this.selectedControllingField) return "";

    let parsedOptions = [];

    parsedOptions = JSON.parse(event.options); // <-- parse string to array
    console.log("parsedOptions", parsedOptions);

    this.sourceOptions = parsedOptions;
  }

  // controllingFieldChange(selectedValue: any) {
  //   console.log("Selected controlling field:", selectedValue);

  //   const selectedField = this.fields.find(
  //     (field) => field.fieldname === selectedValue
  //   );

  //   if (selectedField && selectedField.options) {
  //     let parsedOptions = [];

  //     try {
  //       parsedOptions = JSON.parse(selectedField.options); // <-- parse string to array
  //     } catch (err) {
  //       console.error("Invalid JSON in options:", selectedField.options);
  //     }

  //     this.sourceOptions = parsedOptions.map((opt) => ({
  //       label: opt.label,
  //       value: opt.value,
  //     }));
  //   } else {
  //     this.sourceOptions = [];
  //   }

  //   console.log("Updated sourceOptions:", this.sourceOptions);
  // }

  dependentFieldChange(event: any) {
    console.log("field event", event);
    console.log("field event options", event.options);
    this.selectedDependentField = event.label;
    console.log("selectedDependentField", this.selectedDependentField);
    if (!this.selectedDependentField) return "";
    let parsedOptions = [];

    parsedOptions = JSON.parse(event.options); // <-- parse string to array
    console.log("parsedOptions", parsedOptions);

    this.targetOptions = parsedOptions;
  }

  mappings: { source: any; target: any }[] = [{ source: "", target: "" }];

  addMapping() {
    // console.log("sourceOptions", this.sourceOptions);
    if (this.mappings.length >= this.sourceOptions.length) {
      this.showWarning(
        "You cannot add more mappings than available source options."
      );
      return;
    }
    this.mappings.push({ source: "", target: "" });
    // this.mappings = [{ source: null, target: null }];
  }

  cancel() {
    this.router.navigateByUrl(
      "/home/fielddependencies/list/" +
        this.metaobjectId +
        "/" +
        this.metaobjectName
    );
  }

  getFieldDependencyById() {
    return new Promise((resolve, reject) => {
      console.log(this.metafieldDependencyId);

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getFieldDependencyById(
          domain,
          subdomain,
          organizationid,
          this.metaobjectId,
          this.metafieldDependencyId
        )
        .subscribe(
          (res) => {
            // alert('****res****' + JSON.stringify(res));
            console.log(res);
            if (res.success == 1) {
              this.fieldDependency = res.data.metafielddependency[0];
              console.log("Doneeee****", this.fieldDependency);
              if (this.fieldDependency != null) {
                // this.fieldsDone = this.process.fields;
                // this.id = this.process.id;
                // this.name = this.process.name;

                this.detailForm.controls["controllingfield"].setValue(
                  this.fieldDependency.controllingfieldid
                );
                this.detailForm.controls["dependentfield"].setValue(
                  this.fieldDependency.dependentfieldid
                );

                const controlling = this.fieldList.find(
                  (f) => f.value === this.fieldDependency.controllingfieldid
                );
                const dependent = this.fieldList.find(
                  (f) => f.value === this.fieldDependency.dependentfieldid
                );

                if (controlling) {
                  this.controllingFieldChange(controlling); // Populates sourceOptions
                }
                if (dependent) {
                  this.dependentFieldChange(dependent); // Populates targetOptions
                }

                if (Array.isArray(this.fieldDependency.dependentfieldvalue)) {
                  this.mappings = this.fieldDependency.dependentfieldvalue.map(
                    (item: any) => ({
                      source: item.source,
                      target: Array.isArray(item.target) ? item.target : [],
                    })
                  );
                } else {
                  this.mappings = [];
                }
                // Trigger the UI update
                // setTimeout(() => {
                //   const controlling = this.fieldList.find(
                //     (f) => f.value === this.fieldDependency.controllingfieldid
                //   );
                //   const dependent = this.fieldList.find(
                //     (f) => f.value === this.fieldDependency.dependentfieldid
                //   );
                //   if (controlling) {
                //     this.controllingFieldChange(controlling);
                //   }
                //   if (dependent) {
                //     this.dependentFieldChange(dependent);
                //   }
                //   this.cdr.detectChanges();
                // }, 0);

                // this.filterForm.controls["filterlogic"].setValue(
                //   this.matchingRules.filterlogic
                // );
              }

              // var criterias = res.data.matchingrule.matchingrulecriteria;
              // var index = 0;
              // for (let i = 0; i < criterias.length; i++) {
              //   var criteria = criterias[i];

              //   console.log("fieldname", criteria.fieldname);
              //   //skip id type fields if there
              //   if (criteria.fieldname.toLowerCase() == "deleted") {
              //     console.log("deleted found.");
              //     continue;
              //   }
              //   //skip converted field if object is lead
              //   if (
              //     this.objectName.toLowerCase().trim() == "lead" &&
              //     criteria.fieldname.toLowerCase() == "converted"
              //   ) {
              //     console.log("converted found.");
              //     continue;
              //   }

              //   //get addnl field detail from fields
              //   var fldName = "";
              //   var fldLabel = "";
              //   var fldType = "";
              //   var fldOptions: string;

              //   for (let j = 0; j < this.fields.length; j++) {
              //     if (this.fields[j].id == criteria.fieldid) {
              //       console.log(this.fields[j]);
              //       fldName = this.fields[j].fieldname;
              //       //convert to titecase
              //       fldLabel = this.fields[j].labelname;
              //       fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
              //       fldType = this.fields[j].fieldtype;

              //       if (this.fields[j].options != null) {
              //         fldOptions = this.fields[j].options;
              //       }
              //       //console.log("fldOptions", fldOptions);
              //       break;
              //     }
              //   }

              //   //add item
              //   console.log("criteria", criteria);
              //   this.addFilterItem(
              //     criteria.fieldid,
              //     fldName,
              //     fldType,
              //     fldOptions,
              //     criteria.matchingmethod,
              //     criteria.matchblankfields,
              //     criteria.value
              //   );
              //   if (fldOptions != null) {
              //     var arr = JSON.parse(fldOptions);
              //     this.picklistValueList[index] = arr;
              //   }

              //   index++;
              // }

              this.isLoading = false;
            } else {
              console.log("no data");
              this.isLoading = false;
              //this.resetDetailFormControls();
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            //this.resetDetailFormControls();
          }
        );
    });
  }

  // getFieldDependencyById() {
  //   return new Promise((resolve, reject) => {
  //     console.log(this.metafieldDependencyId);

  //     const organizationid = localStorage.getItem("crm_orgid");
  //     const domain = localStorage.getItem(`${organizationid}.domain`);
  //     const subdomain = localStorage.getItem(`${organizationid}.subdomain`);
  //     this.isLoading = true;

  //     this.dataService
  //       .getFieldDependencyById(
  //         domain,
  //         subdomain,
  //         organizationid,
  //         this.metafieldDependencyId
  //       )
  //       .subscribe(
  //         (res) => {
  //           console.log(res);
  //           if (res.success === 1) {
  //             this.fieldDependency = res.data.metafielddependency;
  //             console.log("Field Dependency:", this.fieldDependency);

  //             if (this.fieldDependency) {
  //               // Set form values
  //               this.detailForm.controls["controllingfield"].setValue(
  //                 this.fieldDependency.controllingfieldid
  //               );
  //               this.detailForm.controls["dependentfield"].setValue(
  //                 this.fieldDependency.dependentfieldid
  //               );

  //               // Find the controlling and dependent fields in fieldList to get labels and options
  //               const controllingField = this.fieldList.find(
  //                 (field) =>
  //                   field.value === this.fieldDependency.controllingfieldid
  //               );
  //               const dependentField = this.fieldList.find(
  //                 (field) =>
  //                   field.value === this.fieldDependency.dependentfieldid
  //               );

  //               // Update selected field labels
  //               this.selectedControllingField = controllingField
  //                 ? controllingField.label
  //                 : "";
  //               this.selectedDependentField = dependentField
  //                 ? dependentField.label
  //                 : "";

  //               // Update sourceOptions and targetOptions
  //               this.sourceOptions =
  //                 controllingField && controllingField.options
  //                   ? JSON.parse(controllingField.options)
  //                   : [];
  //               this.targetOptions =
  //                 dependentField && dependentField.options
  //                   ? JSON.parse(dependentField.options)
  //                   : [];

  //               // Populate mappings if they exist
  //               if (
  //                 this.fieldDependency.mappings &&
  //                 Array.isArray(this.fieldDependency.mappings)
  //               ) {
  //                 this.mappings = this.fieldDependency.mappings.map(
  //                   (mapping) => ({
  //                     source: mapping.source,
  //                     target: mapping.target,
  //                   })
  //                 );
  //               } else {
  //                 this.mappings = [{ source: "", target: "" }]; // Default mapping if none exist
  //               }

  //               this.isLoading = false;
  //               resolve(null);
  //             } else {
  //               console.log("No field dependency data");
  //               this.isLoading = false;
  //               resolve(null);
  //             }
  //           } else {
  //             console.log("No data");
  //             this.isLoading = false;
  //             resolve(null);
  //           }
  //         },
  //         (err) => {
  //           console.log("Error:", err);
  //           this.errorMessage = err.message;
  //           this.isError = true;
  //           this.isLoading = false;
  //           reject(err);
  //         }
  //       );
  //   });
  // }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              // fieldtype: "text",
              // standard: true,
              options: [],
              // id: "",
            });

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              if (field.fieldtype.toLowerCase() !== "picklist") continue;
              if (field.attributes.picklisttype.toLowerCase() !== "static")
                continue;

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                value: field.id,
                label: strLabel,
                // fieldtype: field.fieldtype,
                // standard: field.standard,
                options: field.options,
                // id: field.id,
              });
            }

            console.log("fieldList", this.fieldList);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    if (this.mode.toLowerCase() == "new") {
      this.metafieldDependencyId = this.guid.getGUID("metafielddependency");
      console.log("metaobjectid", this.metaobjectId);
    }
    console.log("mappings", this.mappings);
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),

      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        metafielddependency: {
          id: this.metafieldDependencyId,
          mode: this.mode,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          controllingfieldid: this.detailForm.value.controllingfield,
          dependentfieldid: this.detailForm.value.dependentfield,
          controllingfieldname: this.selectedControllingField,
          dependentfieldname: this.selectedDependentField,
          mappings: this.mappings,
        },
      },
    };
    console.log("postOption", postOption);
    this.isLoading = true;

    this.dataService.upsertMetaFieldDependency(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/fielddependencies/list/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("error while savin");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
